<template>
    <section>
        <PageTitle title="All Billings" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/billings',title:'billings'}]" />
        <div class="wrapper wrapper-content">
            <div class="row">
                <div class="col-lg-7">
                    <div class="ibox-title">
                        <h5>Commission on Orders</h5>
                    </div>
                    <div class="ibox-content c2d_cont_1">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Restaurant</label>
                                        <multiselect v-model="selectedRestaurant" :options="restaurants" :allow-empty="false" placeholder="Select Restaurant" label="name" track-by="name"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Order Source</label>
                                    <multiselect 
                                            select-Label=""
                                            selected-Label=""
                                            deselect-Label="" 
                                            v-model="orderSource"
                                            :options="orderSources"
                                            :multiple="true"
                                            track-by="source" 
                                            label="source"
                                    ></multiselect>
                                </div>
                            </div>                            
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Start Month</label>
                                    <input id="date_range" type="text" readonly="readonly" placeholder="Search By Date" class="form-control date_picker"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" v-if="orderSource.length > 0 && orderSource.find( source => source.id === 7)">
                                <div class="form-group">
                                    <label>Foodpanda Order Id</label>
                                    <input id="foodpandaOrderId" v-model="orderId" type="text" placeholder="Foodpanda order Id" class="form-control date_picker"/>
                                </div>
                            </div>
                            <div :class="orderSource.length > 0 && orderSource.find( source => source.id === 7) ? 'col-md-2' : 'col-md-3'">
                                <div class="form-group">
                                    <label>Total Sale</label>
                                    <input readonly :value="this.totalAmount.toFixed(2)" type="text" class="form-control">
                                </div>
                            </div>
                            <div :class="orderSource.length > 0 && orderSource.find( source => source.id === 7) ? 'col-md-2' : 'col-md-3'">
                                <div class="form-group">
                                    <label>Subtotal</label>
                                    <input readonly :value="this.subTotal.toFixed(2)" type="text" class="form-control">
                                </div>
                            </div>
                            <div :class="orderSource.length > 0 && orderSource.find( source => source.id === 7) ? 'col-md-3' : 'col-md-4'">
                                <div class="form-group">
                                    <label>Total Commission Earned <b class="text-danger">{{this.error}}</b></label>
                                    <input readonly :value="this.commission.toFixed(2)+' '+this.profitConfig" type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-info btn-sm" v-on:click="fetchOrders()"><i class="fa fa-search"></i> Calculate</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                    <div class="sk-bounce1"></div>
                                    <div class="sk-bounce2"></div>
                                    <div class="sk-bounce3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5">
                  <div class="ibox-title">
                    <h5 class="pull-left">Commission Earned Details</h5>
                  </div>
                  <div class="ibox-content c2d_cont_1">
                    <table class="table table-striped table-responsive table-bordered" id="commissionDetails">
                      <thead>
                      <tr>
                        <th>Commission Per Order Charges</th>
                        <th>Orders Total Price Range (Rs.)</th>
                        <th>No of Orders</th>
                        <th>Total Commission (Rs.)</th>
                        <th>Total Price (Rs.)</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr style="white-space: nowrap" v-for="(resCommission, index) in restaurantCommissionDetails" v-bind:key="index+'_resCommission'">
                        <td>{{resCommission.profit}}</td>
                        <td>{{resCommission.profitConfig}}</td>
                        <td>{{resCommission.noOfOrders}}</td>
                        <td>{{parseFloat(resCommission.totalCommission).toFixed(2)}}</td>
                        <td>{{resCommission.totalPrice}}</td>
                      </tr>
                      <tr>
                        <td colspan="5" v-if="restaurantCommissionDetails.length === 0" style="text-align: left">No Profit Configuration.</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
            </div>
            <br/>
            <div class="row" v-if="ordersFetched===true">
              <div class="col-md-12">
                <div class="ibox-content">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover" id="dtTable">
                    <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Branch Name</th>
                      <th>Customer Name</th>
                      <th>Customer address</th>
                      <th>Customer Area</th>
                      <th>City</th>
                      <th>Subtotal</th>
                      <th>Delivery fee</th>
                      <th>Total amount</th>
                      <th>Tax amount</th>
                      <th>Discount</th>
                      <th>Billed price</th>
                      <th>Commission</th>
                      <th>Placed on</th>
                      <th>Placing time</th>
                      <th>Last updated</th>
                      <th>Updated time</th>
                      <th>Order type</th>
                      <th>Order source</th>
                      <th>Taken by</th>
                      <th>Status</th>
                      <th>Cancellation reason</th>
                      <th>Cancellation reason note</th>
                      <th>Order wide instructions</th>
                      <th>Payment method</th>
                      <th>Payment status</th>
                      <th>Km distance covered by rider</th>
                      <th>Assigned rider name</th>
                      <th>assigned rider number</th>
                      <th class="text-center"><i class="fa fa-bolt"></i></th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="order in restaurantAllOrders" :key="order.id" >
                      <th>{{ order.orderId }}</th>
                      <td>{{ (order.branchName!== null ) ? order.branchName : "N/A"}}</td>

                      <td v-if="order.baykedCustomerName !== null">{{order.baykedCustomerName}}</td>
                      <td v-else>{{ getValidString(order.customerName) }}</td>

                      <td>{{ (order.address !== null && order.address !== "Dummy") ? order.address : "N/A"}}</td>
                      <td>{{ getValidAreaAndCity(order, order.areaName) }}</td>
                      <td>{{ getValidAreaAndCity(order, order.cityName) }}</td>
                      <td>{{ getValidString(order.subTotal) }}</td>
                      <td>{{ order.deliveryFee }}</td>
                      <td>{{ order.totalAmount !== null ?  order.totalAmount + order.deliveryFee : order.deliveryFee }}</td>
                      <td v-if="order.paymentMethodId === 1 || order.paymentMethodId === 3">{{ ((order.tax /100) * order.totalAmount).toFixed(2) }}</td>
                      <td v-else>{{ ((order.cardTax /100) * order.totalAmount).toFixed(2) }}</td>

                      <td>{{ order.discount }}</td>
                      <td>{{ getValidString(order.billedPrice) }}</td>
                      <td>{{ order.commission !== null ? order.commission.toFixed(2) : "N/A" }}</td>
                      <td>{{ order.orderCreated.split(" ")[0] }}</td>
                      <td>{{ order.orderCreated.slice(order.orderCreated.indexOf(' ') + 1) }}</td>
                      <td>{{ order.orderModified.split(" ")[0] }}</td>
                      <td>{{ order.orderModified.slice(order.orderCreated.indexOf(' ') + 1) }}</td>
                      <td>{{ getValidString(order.orderTypeName) }}</td>
                      <td>{{ getValidString(order.orderSourceName) }}</td>
                      <td>{{ (order.agentName !== null) ? order.agentName : "bayked Order"}}</td>
                      <td>{{ getValidString(order.statusName) }}</td>
                      <td>{{ getValidString(order.cancellationReason) }}</td>
                      <td>{{ getValidString(order.otherCancellationReasons) }}</td>
                      <td>{{ getValidString(order.orderWideInstructions) }}</td>
                      <td>{{ getValidString(order.paymentMethodName) }}</td>
                      <td>{{ getValidString(order.paymentStatusName) }}</td>
                      <td>{{ getValidString(order.totalDistance) }}</td>
                      <td>{{ getValidString(order.riderName) }}</td>
                      <td>{{getValidString(order.riderContactNumber) }}</td>

                      <td><a class="btn btn-xs btn-primary view_btn" v-on:click="fetchOrderDetail(order.orderId)">View</a></td>

                    </tr>

                    </tbody>
                  </table>
                </div>
              </div>
              </div>
            </div>
        </div>
        <ViewOrder showActions="true" ref="viewOrderComp"/>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import ViewOrder from '@/components/orders/ViewOrder'
    import User from '@/services/User'
    import Multiselect from 'vue-multiselect'
    import {getRestaurantCancelledOrders} from "../api/orders";
    import store from "../store";
    import moment from "moment";

    export default {
        name: "Billings",
        data() {
            return {
                orders:[],
                cancelledOrders: [],
                restaurantAllOrders: [],
                restaurantCommissionDetails: [],
                restaurants:[],
                isHideSpinner: "hide",
                selectedRestaurant: "",
                profitConfig:"",
                error:"",
                subTotal:0,
                totalAmount:0,
                commission:0,
                totalDelivery:0,
                ordersFetched:false,
                selectedYear: "",
                selectedMonth: '',
                loggedInRole: "",
                defaultRestaurant: "",
                Year: new Date().getFullYear(),
                startMonth:1,
                endMonth:1,
                currentYear :new Date().getFullYear(),
                loggedInUser :this.$store.state.user,
                orderSources:[],
                orderSource:[],
                orderId: "",
                columnNumbers: Array.from(Array(29), (_, index) => index)
            }
        },
        components: {
            PageTitle,
            ViewOrder,
            Multiselect
        },
        mounted: function () {
            $('.date_picker').daterangepicker({
                format: 'YYYY-MM-DD',
                maxDate: new Date,
                minDate: moment().subtract(3,'M')
            }).on('apply.daterangepicker', function(ev, picker) {
                $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
            }).on('cancel.daterangepicker', function(ev, picker) {
                $(this).val('');
            });
        },
        created: function () {

          User.fetchUserRoles().then(role => {
              this.loggedInRole = role;
              if(role === 'ROLE_ADMIN' || role === 'ROLE_AGENT'){
                  this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                      this.restaurants = resp.data;
                      console.log(this.restaurants);
                  });
              }else if(role === 'ROLE_USER' || role === 'ROLE_FRANCHISE'){
                  this.selectedRestaurant = this.$store.state.user.restaurant;
                  this.defaultRestaurant = this.$store.state.user.restaurant;
                  this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
              }
          });

          this.$http.get(this.$store.state.mainAppURL + "orders/get_all_order_source").then(resp=>{
              this.orderSources= resp.data;
          });

        },
        methods: {
            getValidCustomerAddress: function (dvmCustomerAddress){
              if(dvmCustomerAddress.id === store.getters.takeAwayAddressId){
                return "N/A";
              }
              return dvmCustomerAddress.address;
            },
            getValidString: function(stringValue){
              if(stringValue !== null && stringValue !== ""){
                return stringValue;
              }
              return "N/A";
            },
            getValidAreaAndCity: function(order, data){
              if(order.orderTypeName !== "Delivery" || order.orderTypeName === "" || order.orderTypeName === null){
                return "N/A";
              }return data;
            },
            getBase64Image: function(img) {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                return canvas.toDataURL("image/png");
            },
            fetchOrderDetail: function (orderId) {
                this.$refs.viewOrderComp.fetchOrderDetail(orderId);
            },
            fetchOrders:async function () {
              let dateRange = $("#date_range").val().split(" <==> ")
              if (dateRange[0] === '') {
                swal("Error!", "Kindly Select Date Range", "error");
                return;
              }
              if (this.selectedRestaurant !== '') {
                $('#restaurant').css('border-color', '');
                this.orders = [];
                this.profitConfig = "";
                this.error = "";
                this.commission = 0;
                this.totalAmount = 0;
                this.totalDelivery = 0;
                this.subTotal = 0;
                this.isHideSpinner = "";
                this.ordersFetched = false;
                let start = dateRange[0];
                let end = dateRange[1];
                let params = new URLSearchParams();
                params.append("start", start);
                params.append("end", end);
                params.append("restaurant_id", this.selectedRestaurant.id);
                params.append("foodpanda_order_id", this.orderId)
                for (let os of this.orderSource) {

                  console.log(os.id);
                  params.append("order_source", os.id);
                }
                let restaurantCancelledOrdersResp = await getRestaurantCancelledOrders(params);
                this.cancelledOrders = restaurantCancelledOrdersResp.data;
                this.$http.post(this.$store.state.mainAppURL + "orders/get_restaurant_orders", params).then(resp => {
                  if (this.selectedRestaurant.id > 0) {
                    let selectedData = new URLSearchParams();
                    selectedData.append("start", start + " 00:00:00.0");
                    selectedData.append("end", end + " 23:59:59.0");
                    selectedData.append("restaurant_id", this.selectedRestaurant.id);
                    this.$http.get(this.$store.state.mainAppURL + "restaurants/get_commission_earned", {
                      params: selectedData
                    }).then(commissionEarnedDetails => {
                      this.restaurantCommissionDetails = commissionEarnedDetails.data;
                    });
                  }
                  this.isHideSpinner = "hide";
                  this.ordersFetched = true;
                  this.orders = resp.data;
                  this.orders.forEach((item, index) => {
                    item.orderCreated = this.$moment.parseZone(String(item.orderCreated)).local().format('DD-MM-YYYY hh:mm:ss A');
                    item.orderModified = this.$moment.parseZone(String(item.orderModified)).local().format('DD-MM-YYYY hh:mm:ss A');
                    this.subTotal += (item.totalAmount + item.deliveryFee);
                    this.totalAmount += item.billedPrice;
                    this.totalDelivery += item.deliveryFee;
                    resp.data === "Null" ? this.commission = 0 : this.commission += item.commission;
                  });

                  this.cancelledOrders.forEach((item, index) => {
                    item.orderCreated = this.$moment.parseZone(String(item.orderCreated)).local().format('DD-MM-YYYY hh:mm:ss A');
                    item.orderModified = this.$moment.parseZone(String(item.orderModified)).local().format('DD-MM-YYYY hh:mm:ss A');
                  });
                  this.restaurantAllOrders = this.orders.concat(this.cancelledOrders)
                  let self = this;
                  let logo = new Image();
                  logo.src = '/img/dm-logo-new.png';
                  setTimeout(function () {
                    $('#dtTable').DataTable({
                      "paging": true,
                      "ordering": false,
                      "lengthMenu": [10, 25, 50, 75, 100, 250],
                      "scrollX": true,
                      "columnDefs": [
                        {
                          "width": "4%",
                          "targets": self.columnNumbers
                        },
                        {
                          'className': "text-center",
                          'aTargets': self.columnNumbers
                        }
                      ],
                      "dom": "<'row'<'col-md-8'" +
                          "<'row'<'col-md-5'" +
                          "<'row'<'col-md-5'B><'col-md-3'l>>>>>" +
                          "<'col-md-4'f>>" +
                          "<'row'<'col-md-12't>>" +
                          "<'row'<'col-md-6'i><'col-md-6'p>>",
                      buttons: [
                        {
                          extend: 'csv',
                          className: "btn btn-primary",
                          filename: self.selectedRestaurant.name + ' Sales Report (' + start + ' to ' + end + ')',
                          exportOptions: {
                            columns: Array.from(Array(28), (_, index) => index)
                          },
                        }
                      ]
                    });
                  }, 500);
                });
              } else {
                $('#restaurant').css('border-color', '#C80000');
              }
            }

        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.wrap_class{
    white-space: nowrap;
}
.c2d_cont_1{
  height: 220px !important;
  overflow: auto;
}
th, #commissionDetails{
  text-align: center;
}
</style>
